module.exports = __webpack_public_path__ + "img/second-day-8.c1d01a36.webp";